module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/Users/alexholachek/Desktop/test/deck.mdx",
    "dirname": "/Users/alexholachek/Desktop/test"
  }
}];